import React, { Suspense, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import CustomPageLoader from "../component/customPageLoader";
import { maintenance } from '../config/config';
import { isDeveloperr, userData } from "../config/sessionKeys";
import siteConfig from "../config/site-config";
import Error404 from '../pages/Error404/Error404';
import Maintenance from "../pages/maintenence/maintenance";
import { private_routes, public_private_routes, public_routes } from './layouts-routes';
import pages_path from "./path";
import { RouteRestriction } from "./route-restriction";

const MainRoutes = () => {
    const maintenances = maintenance;
    const isDeveloper = localStorage.getItem(isDeveloperr)
    const jwt_token = JSON.parse(localStorage.getItem(userData));

    // Favicon icon set...
    useEffect(() => {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = siteConfig.company_favicon;
    }, []);

    return maintenances && isDeveloper !== 'true' ? (
        <Maintenance/>
    ) : (
        <>
            <Routes>
                {/* Public Private Routes */}
                <Route exact path='/' element={<RouteRestriction type="both"/>}>
                    {public_private_routes.map(({path, Component, Layout}, i) => (
                        <Route element={Layout} key={i}>
                            <Route exact path={path} element={<Suspense fallback={<CustomPageLoader default/>}>{Component}</Suspense>}/>
                        </Route>
                    ))}
                </Route>

                {/* Private Routes */}
                <Route exact path='/' element={<RouteRestriction type="private"/>}>
                    {private_routes.map(({path, Component, Layout}, i) => (
                        <Route element={Layout} key={i}>
                            {jwt_token && <Route exact
                                path={`/`}
                                element={<Navigate to={`${process.env.PUBLIC_URL}${pages_path.dashboard}`}/>}
                            />}
                            <Route exact path={path} element={<Suspense fallback={<CustomPageLoader default/>}>{Component}</Suspense>}
                            />
                        </Route>
                    ))}
                </Route>

                {/* Public Routes */}
                <Route exact path='/' element={<RouteRestriction type="public"/>}>
                    {public_routes.map(({path, Component, Layout}, i) => (
                        <Route element={Layout} key={i}>
                            <Route exact path={path} element={<Suspense fallback={<CustomPageLoader default/>}>{Component}</Suspense>}/>
                        </Route>
                    ))}
                </Route>

                {/* Error Routes */}
                <Route path={`${process.env.PUBLIC_URL}${pages_path.error404}`} element={<Error404 pageTitle="Error"/>}/>
                <Route path="*" element={<Error404 pageTitle="Error"/>}/>
            </Routes>
        </>
    );
};

export default MainRoutes;